/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccessTokenDtoFromJSON, AccessTokenDtoToJSON, } from './AccessTokenDto';
/**
 * Check if a given object implements the MyPlaylistIdRequestDto interface.
 */
export function instanceOfMyPlaylistIdRequestDto(value) {
    if ((!('playlistId' in value) && !('playlist_id' in value)) || (value['playlistId'] === undefined && value['playlist_id'] === undefined))
        return false;
    if (!('limit' in value) || value['limit'] === undefined)
        return false;
    if (!('offset' in value) || value['offset'] === undefined)
        return false;
    return true;
}
export function MyPlaylistIdRequestDtoFromJSON(json) {
    return MyPlaylistIdRequestDtoFromJSONTyped(json, false);
}
export function MyPlaylistIdRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'playlistId': json['playlist_id'],
        'limit': json['limit'],
        'offset': json['offset'],
        'token': json['token'] == null ? undefined : AccessTokenDtoFromJSON(json['token']),
    };
}
export function MyPlaylistIdRequestDtoToJSON(json) {
    return MyPlaylistIdRequestDtoToJSONTyped(json, false);
}
export function MyPlaylistIdRequestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'playlist_id': value['playlistId'],
        'limit': value['limit'],
        'offset': value['offset'],
        'token': AccessTokenDtoToJSON(value['token']),
    };
}
